import { DisplayPosition } from '@/type/display-position';
import { __advancedConfig__ } from '@/common/util/const';
import { setAdvancedConfigToProps, } from '@/common/util/util';
import isPlainObject from 'lodash/isPlainObject';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.filter,
        DisplayPosition.cnArrayTable,
    ],
    title: '员工选择器',
    componentName: 'CnEmployeeSelect',
    // component: CnEmployeeSelect,
    // formComponent: formComponentMap.CnEmployeeSelect,
    getDefaultProps: () => {
        return {
            mode: 'single',
            serviceType: 'cainiao',
            __advancedConfig__: {
                isOnJob: true,
            },
        };
    },
    formItemBeforeHandler: (formItem, config) => {
        if (formItem) {
            const componentProps = formItem['x-component-props'];
            if (isPlainObject(componentProps)) {
                if (componentProps.serviceType !== 'ali') {
                    componentProps.serviceType = 'cainiao';
                }
            }
            setAdvancedConfigToProps(componentProps);
        }
    },
    getFormItemDefaultProps: () => {
        return {
            placeholder: '请选择',
        };
    },
    getPrototypeList: () => {
        return [
            {
                name: 'mode',
                title: '选择模式',
                display: 'inline',
                setter: {
                    componentName: 'RadioGroupSetter',
                    props: {
                        options: [
                            {
                                title: '单选',
                                value: 'single',
                            },
                            {
                                title: '多选',
                                value: 'multiple',
                            },
                        ],
                    },
                },
            },
            {
                name: 'serviceType',
                display: 'inline',
                title: '数据来源',
                setter: {
                    componentName: 'RadioGroupSetter',
                    props: {
                        options: [
                            {
                                title: '菜鸟',
                                value: 'cainiao',
                            },
                            {
                                title: '集团',
                                value: 'ali',
                            },
                        ],
                    },
                },
            },
            {
                name: 'mokelay',
                display: 'inline',
                title: '是否中心化',
                setter: {
                    componentName: 'RadioGroupSetter',
                    props: {
                        options: [
                            {
                                title: '是',
                                value: true,
                            },
                            {
                                title: '否',
                                value: false,
                            },
                            {
                                title: '默认值',
                            },
                        ],
                    },
                },
            },
            {
                title: '高级配置',
                name: __advancedConfig__,
                display: 'accordion',
                extraProps: {
                    defaultCollapsed: true,
                },
                setter: {
                    componentName: 'ObjectSetter',
                    props: {
                        config: {
                            items: [
                                {
                                    title: '员工属性（默认自有）',
                                    name: 'typeList',
                                    display: 'inline',
                                    setter: {
                                        componentName: 'CnSelectSetter',
                                        props: {
                                            options: [
                                                {
                                                    label: '自有',
                                                    value: 'REGULAR',
                                                },
                                                {
                                                    label: '外包',
                                                    value: 'OUTSOURCING',
                                                },
                                                {
                                                    label: '临时工',
                                                    value: 'CASUAL',
                                                },
                                            ],
                                            selectProps: {
                                                hasClear: true,
                                                // 开启多选
                                                mode: 'multiple',
                                            },
                                        },
                                    },
                                },
                                {
                                    name: 'isOnJob',
                                    title: '是否在职（默认在职）',
                                    display: 'inline',
                                    setter: {
                                        componentName: 'RadioGroupSetter',
                                        props: {
                                            options: [
                                                { title: '在职', value: true },
                                                { title: '离职', value: false },
                                            ],
                                        },
                                    },
                                },
                            ],
                        },
                    },
                },
            },
        ];
    },
};
